import { TExperiment, TExperimentsState } from '../../types/experiment';

export function getExperiment(experiments: TExperimentsState, experimentName: string): TExperiment | undefined {
  return experiments.find(o => o.experimentName === experimentName);
}
